/* eslint-disable */
/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

import { UpdateCompuweighRequest } from './data-contracts';
import { ContentType, HttpClient, RequestParams } from './http-client';

export class CompuweighMassUpdates<
  SecurityDataType = unknown,
> extends HttpClient<SecurityDataType> {
  /**
   * No description
   *
   * @name UpdateCompuweigh
   * @request POST:/compuweigh-mass-updates
   * @secure
   */
  updateCompuweigh = (data: UpdateCompuweighRequest, params: RequestParams = {}) =>
    this.request<void, any>({
      path: `/compuweigh-mass-updates`,
      method: 'POST',
      body: data,
      secure: true,
      type: ContentType.Json,
      ...params,
    });
  /**
   * No description
   *
   * @name OptionsCompuweighMassUpdates
   * @request OPTIONS:/compuweigh-mass-updates
   */
  optionsCompuweighMassUpdates = (params: RequestParams = {}) =>
    this.request<void, any>({
      path: `/compuweigh-mass-updates`,
      method: 'OPTIONS',
      ...params,
    });
}
